import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { BG_IMAGE_ALIGNMENT_OPTIONS, BgImageAlignmentOptions, Icon } from '#const';
import { getIconUrl } from '#utils';

const Form = dynamic(() => import('./Form'));

Builder.registerComponent(Form, {
	name: 'Form',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Show Heading',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Show the heading above the form',
		},
		{
			name: 'color',
			friendlyName: 'Form Heading & Border Color',
			type: 'color',
			defaultValue: 'rgba(255,219,0, 1)',
			helperText: `For the colored outline around the form,
			make sure there is enough contrast with the Heading`,
			showIf: function (options) {
				return options.get('heading') === true;
			},
		},
		{
			name: 'headingCopy',
			friendlyName: 'Heading',
			type: 'richText',
			defaultValue: `<h2>Find Out if You Qualify</h2>
				<br/> <h3><u>SIGNIFICANT</u> Compensation May Be Available</h3>`,
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('heading') === true;
			},
		},
		{
			name: 'form',
			friendlyName: 'Form',
			type: 'reference',
			model: 'form',
			defaultValue: {
				'@type': '@builder.io/core:Reference',
				id: 'f86c3b6d48c94d8da964dd705d15438c',
				model: 'form',
			},
		},
		{
			name: 'showFinePrint',
			friendlyName: 'Show TCPA',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true will show TCPA. TCPA is REQUIRED for any forms. 
			This option allows it to be removed from the first step`,
		},
		{
			name: 'showLogos',
			friendlyName: 'Show Logos',
			type: 'boolean',
			defaultValue: true,
			helperText: 'If TCPA text is shown this is an option to show or hide logos',
		},
		{
			name: 'finePrint',
			friendlyName: 'Fine Print',
			type: 'richText',
			required: false,
			defaultValue: `<p>
				By clicking &apos;Do I Qualify&apos; and submitting my request,
				I confirm that I have read and agree to the privacy policy of
				this site and that I consent to receive emails, phone calls and/or text
				message offers and communications from Total Injury Help and its network
				of lawyers and advocates at any telephone number or email address
				provided by me, including my wireless number, if provided. I
				understand there may be a charge by my wireless carrier for such
				communications. I understand these communications may be generated using
				an autodialer and may contain pre-recorded messages and that consent
				is not required to utilize Total Injury Help services. I understand
				that this authorization overrides any previous registrations on a federal
				or state Do Not Call registry. Accurate information is required
				for a free evaluation.
				</p>`,
		},
		{
			name: 'centered',
			friendlyName: 'Center Form',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Center the form container on the page',
		},
		{
			name: 'maxWidth',
			friendlyName: 'Form Max Width',
			type: 'number',
			defaultValue: 425,
			helperText: 'Max width of the form container in pixels (default: 425px)',
		},
		{
			name: 'backgroundImage',
			friendlyName: 'Background Image',
			type: 'object',
			required: false,
			helperText: 'Optional image placed in the background.',
			subFields: [
				{
					name: 'src',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'backgroundImagePlacement',
					friendlyName: 'Background Image Placement Bias',
					type: 'string',
					enum: [...BG_IMAGE_ALIGNMENT_OPTIONS],
					defaultValue: BgImageAlignmentOptions.CENTER,
					helperText: `How the background Image will attach to the background of the container.
						Use it to move the focal point of the image if needed.`,
				},
			],
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			helperText: 'Background color behind the form, shown if no background image is provided',
		},
	],
	canHaveChildren: false,
	image: getIconUrl(Icon.FORM),
});
